import { render, staticRenderFns } from "./Kyc.vue?vue&type=template&id=1b6703aa&scoped=true&"
import script from "./Kyc.vue?vue&type=script&lang=js&"
export * from "./Kyc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6703aa",
  null
  
)

export default component.exports